const OrderEnum={
    orderToPaid:1,
    orderToConfirm:2,
    orderIsConfirmed:3,
    orderToRefund:4,
    orderCanceled:5,
    orderMealDone:6,
    orderRefundDepositReceipt:7,
    orderFinish:8,
    orderClose:9,
}
const EnumAgreement={
    fuwu:1,
    yinsi:2,
    tuikuan:3,
    yuyue:4,
    shiyong: 5,
    guanyu:6,
}

export { OrderEnum,EnumAgreement }